import dsBridge from '@/api/dsbridge.js'
import api from '@/api/api.js'
import httpAxios from '@/api/http'
import Mshare from "m-share";
import {
	Toast
} from 'vant'
import wx from 'weixin-js-sdk';
let util = {
	setTitle(title) {
		title = title || '防疫服务平台';
		window.document.title = title;
		if (this.hasNative()) {
			dsBridge.dsCall('setTitles',title)
		}
	},
	isEquipment() { //判断页面的打开环境
		let UA = navigator.userAgent,
			isAndroid = /android|adr|linux/gi.test(UA),
			isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid,
			isBlackBerry = /BlackBerry/i.test(UA),
			isWindowPhone = /IEMobile/i.test(UA),
			isMobile = isAndroid || isIOS || isBlackBerry || isWindowPhone,
			isApp = this.hasNative(),
			isQQbrw = UA.indexOf('MQQBrowser') > -1;
		return {
			isAndroid: isAndroid, //是安卓
			isIOS: isIOS, //是苹果
			isMobile: isMobile, //是手机
			isWeixin: /MicroMessenger/gi.test(UA), //是微信
			isQQ: /QQ/gi.test(UA), //是QQ
			isQQbrw: isQQbrw,
			isPC: !isMobile, //是PC
			isWeibo: /WeiBo/gi.test(UA),
			isApp: isApp || false //是app
		}
	},
	hasNative() { //判断是否在app打开
		return dsBridge.dsHas('getDeviceType')
	},
	appId: '',
	timestamp: '',
	nonceStr: '',
	signature: '',
	getWxSignature(url, callback) { // 获取微信参数
		let _that = this;
		let ip = window.location.host; //获取服务器ip地址
		let protocolStr = document.location.protocol; // 协议头
		url = url == '/' ? url = '' : url;
		let urls = url ? `${protocolStr}//${ip}/pckm${url}` : window.location.href;
		httpAxios
			.get(api.getSignature, {
				url: urls
			}, true)
			.then(data => {
				callback(data);
			});
	},
	arouseShare(value = '/') { //唤醒app
		if (!this.isEquipment().isApp) {

			// 分享出去的
			let timer = null,
				isAndroid = false,
				isiOS = false,
				isQQandWechat = false;
			// 验证终端
			isAndroid = this.isEquipment().isAndroid; //android终端或者uc浏览器
			isiOS = this.isEquipment().isIOS; //ios终端
			isQQandWechat = this.isEquipment().isQQ || this.isEquipment().isWeixin

			// 侦听页面隐藏
			window.addEventListener(
				"pagehide",
				function() {
					clearTimeout(timer);
				},
				false
			);

			let ip = window.location.host; //获取服务器ip地址
			let protocolStr = document.location.protocol; // 协议头
			let goUrl = null;
			if (value.indexOf('?') > 0) {
				goUrl = `${protocolStr}//${ip}/pckm/${value}&activityKey=dcthreeyears_`;
			} else {
				goUrl = `${protocolStr}//${ip}/pckm/${value}?activityKey=dcthreeyears_`;
			}
			let parameterUrl = `pageType=threeyears&activityKey=dcthreeyears_&url=${goUrl}`;

			//ios专用
			let iosParameterUrl = `https://dc300.netwin.cn/pckm/mobileCodeDown`;
			// let iosParameterUrl = `https://www.netwin.cn/netyun/app/index.html?activityKey=dcthreeyears_`;


			// 微信或qq
			if (isQQandWechat) {
				if (isAndroid) {
					location.href =
						`https://a.app.qq.com/o/simple.jsp?pkgname=com.nayun.framework&android_schema=` +
						encodeURIComponent("duchuang://?" + parameterUrl);
					// "duchuang://" + parameterUrl
					return false;
				} else if (isiOS) {
					//提示
					location.href = iosParameterUrl;
					// Toast.success("请使用safari浏览器打开去app进行登入操作");
				} else {
					//去引导页
					Toast('需要在app打开进行操作')
				}
			} else {
				// 浏览器打开
				if (isiOS) {
					location.href = iosParameterUrl;
					// location.href = "https://apps.apple.com/cn/app/id1176844306";
				} else if (isAndroid) {
					this.getAnVersion(value);
					let openTime = +new Date();
					location.href = "duchuang://?" + parameterUrl;
					let _this = this;
					timer = window.setTimeout(function() {
						if (new Date() - openTime < 2200) {
							window.location.href = _this.anVersion;
						}
						if (new Date() - openTime > 2200) {
							clearTimeout(timer);
							timer = null
						}
					}, 2000);
				} else {
					Toast('需要在app打开进行操作')
				}
			}

		} else {
			Toast('是在app打开的')
		}
	},
	anVersion: '',
	getAnVersion(value) { //获取安卓的最新下载地址
		httpAxios.get3(api.anVersion).then(data => {
			if (data.success) {
				this.anVersion =
					"http://300w.oss-cn-shenzhen.aliyuncs.com/" +
					data.rtn.data.rtnObj.loadUrl;
			}
		});
	},
	// 获取url参数
	getUrlParam(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
		var r = window.location.search.substr(1).match(reg); //匹配目标参数
		if (r != null) {
			return decodeURI(r[2]);
		} else {
			return null; //返回参数值
		}

	},
	getLoader(url, option = {}) {
		var _that = this;
		let ip = window.location.host; //获取服务器ip地址
		let protocolStr = document.location.protocol; // 协议头
		let urlss = `${protocolStr}//${ip}/pckm${url}`;

		if (_that.isEquipment().isWeixin || _that.isEquipment().isQQ) {
			_that.getWxSignature(url, function(data) {
				wx.config({
					debug: false, // true:调试时候弹窗
					appId: data.appId, // 必填，公众号的唯一标识
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名
					jsApiList: [
						// 所有要调用的 API 都要加到这个列表中
						'onMenuShareTimeline', // 分享到朋友圈接口
						'onMenuShareAppMessage', // 分享到朋友接口
						'onMenuShareQQ', // 分享到QQ接口
						'onMenuShareWeibo', // 分享到微博接口
						'updateTimelineShareData',
						'updateAppMessageShareData'
					]
				})

				wx.ready(function() {
					var shareData = {
						link: urlss, // 覆盖分享到微信的链接
						title: option.title || '新型冠状病毒感染的肺炎科普与服务平台', // 覆盖分享到微信的标题
						desc: option.desc || '科学疫情防范，你该知道的都在这里！', // 覆盖分享到微信的标题
						imgUrl: 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
						success: function() {
							// 分享成功可以做相应的数据处理

						},
						fail: function() {
							// Toast('请点击右上角进行分享操作!')
							// alert('调用失败')
						},
						complete: function() {
							// alert('调用结束')
						}
					}

					wx.onMenuShareQQ(shareData)
					wx.onMenuShareWeibo(shareData)
					wx.onMenuShareAppMessage(shareData)
					wx.onMenuShareTimeline(shareData)
					wx.updateTimelineShareData(shareData)
					wx.updateAppMessageShareData(shareData)
				})

			})
		} else {
			Toast('需要在微信或QQ或app打开进行操作分享')
		}
	},
	getH5Share(opthions, url) {
		let _that = this;
		if (_that.isEquipment().isWeixin) { //微信的分享

			let html =
				`<div id="cover"></div><div id="shareTC"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAADkCAMAAADJlp0dAAACl1BMVEUAAAAAAACPj4////8AAAD///8AAADKysr///8AAABLS0v////y8vIAAAD///////8BAQEAAAAAAAD///8AAADm5ub///8UFBQAAADY2NgBAQH///8AAACtra1ubm4BAQH///////+8vLz///86Ojqenp5+fn4nJyf///8AAAD///8AAAAAAABdXV3////g4OD09PT6+vrS0tL29vYCAgLi4uLz8/Ps7Oy5ubn///+hoaHp6en09PTMzMwCAgIDAwMDAwP9/f3l5eVdXV38/PyEhITKysoAAACRkZH///9JSUklJSX6+vr+/v7T09MRERHw8PDDw8Pc3NxycnK+vr6ZmZk7OzthYWHa2tr19fXr6+t0dHT6+vp1dXWPj4/+/v4PDw8CAgK4uLj///9mZmbX19f///////+pqanX19c1NTX////u7u7+/v7Pz88/Pz////+kpKTq6upPT0////+Pj4/GxsbGxsb+/v6lpaXg4OAAAADU1NT////+/v53d3fd3d0AAABubm4EBAQxMTHo6Oibm5tra2sBAQH+/v7FxcX+/v7////d3d0SEhLLy8urq6v+/v5TU1MVFRWXl5etra0uLi6GhoYdHR2amprGxsYjIyO1tbUjIyPh4eEAAAAwMDB/f39OTk7b29s5OTlubm6Tk5MpKSmCgoLb29sYGBhOTk6np6f///9JSUlERESOjo7///82Nja0tLRAQEAGBgZgYGBGRkZ1dXWLi4sAAAC/v799fX3i4uIAAABra2vz8/NLS0ubm5s/Pz/////7+/v39/e4uLgdHR3z8/Po6OhjY2NWVlbGxsaurq7j4+PAwMCTk5MVFRXOzs5/f38NDQ3X19exsbGjo6OampouLi52dnaKiopAEShxAAAAxHRSTlMAyeSAZcCX8kAy1xD+DPIgGb0mMEz4YM0/9VjQpOzdfqBw7lDT5+HQsIvhcrHakO779er5BtnM87D4yuXa79T57taysBXZyiwcDP7+5cCII/Dl39fW1sl+8+q+jG1oVUsT4eDcx763qaiYlpSJRDz+6uLSzszIuaV5Y1pTTTspzMvDuK2kn5+ZhjYrGwf+8N3WycTBvbyvmJKEfHxxb2xcWEI0Bf793sO7qKGdkoeHeHRWS0Q/Os6uraqdlIJ+bEy4azTA2OkjawAAIn1JREFUeNrs3OtvS2EcB/BnLo1xWlXCMEpcstVCJCdoSC8iabSZukVCFlqVNrHQkYVFkTRLqDGyd+IueEl4QYJEQr6np/f7tm7zx2g7o60ew7N49fu83Pbqm+ec5/d7fs8ZI+S/cOme3WJkBrjaH55ZyAg/UWXZ0b2HEW7qdnMB3YxwU6uGJ8LoY4SX64O5IMHYxQgnV+twFoBmHSN8tP2VJGGYxwgXZ8fwGMo8ixnhoVuUK6LCSmUlF1tTJIVJvRQlD21HTsZ3c6lC56BuzRUhhSEBEnzUgnMQP62WSlFGo4CE7meM1BJtjzeF7t69e/r+EyebzsC+A2lI5TzxkpEarsCHZf5CcVTOZDLyufdP2XScpzJAOcq1jFQRAx2346MxTIkOXhxgv6ddlIiiRPOGkZ+cKktCDpdz8Wzbtm3XfkFC+Pxl9lt6cxbGgyMw3GDkh4DJMRYGNN6+M1dv7tlz9eyDwzFg/wn2G2/diTB6B44f66Rm5wdxk8WeB4xt634WiNrrMmC9wRSJH3KZypnQrYVUVk4R9eZ4DLB2Laj56ekU0LaAKVlhflH5PanyyRwXAG/9CnQeSUKzlCnQmcYH0XOGkSqPLYkYjA3GM5/iUbTtVXy8R0G1eS2n6Xka2NwgMt0yGQaFdTen/Hj3XmWkemA4nALW7G3YZ08AfQq7tz+GnhOMVGmxxCUMLWSNhBICNjc+FopkQHPGWmJ7LqnYrsx5PgLfrYYreQzovMlIzUacCMO3V2FDciQb7jubzBOA4QojNWmZx8oDQ6UoM/D+GmWgsuUvZaRGu2NEeZ4wpxzlHlanxe0fBB2s1VP32wWsuaVUuzvy6FxQn6RpPA/4qM2pow3Gf3O3Qj8+Au+C+umYIwl4aTBWz2YqKL8qRZU/Xb/t2IIRGRii2vwXzaascpTqDnsU3bV/31RO0koHlA2idI9Bc0axUHoBrK1N0iEDHjrEaPiAjyn3f0sspZxP1Ow4lKQiXdNX5dFMKJKHteqtuML9PAlY6a6VwqSroFhsa4P2KNY8qz5qHwF6qclRasHjind2A+avVYWSOmSJx4Ah2nGUzPEPKrTgYqsjD8/U893cMVwQAB/Vk4psy2T0XGl8+vZC+tEIBUzjowDW0EBMmRiakBoe/KpbI8mp2Y02VJlI9vTtZUSZbX0SW7savSknMPnoi0uCka8CYKUb59NY8ULA0Uusjis4PjhZVDarbieSgNFHG8609Flg5+UGl1jKTaMuZHpeFABDHx0FTU99Wga2f3TVNjoJAb0DNr1pPBsDjG1UTf4R8VUqDOHOayeb4gw6RmC8pjLZs2nAuLKLluSfenJOANIn339+22xzOrXN/bkicNIeTwkAPLOpmPwLzmvLw4CQX7Xx0KF37+bbi0A4mZcAWF/SPbW/9HTHlihKJCGWTscwqce7lg55/8GXe7t37Q/jO2mroW32Cepu/tGzgbOPZl+YJYcBb9e6K5Qj7+d2ERnw0s2LmUhylMZgM8G2KJICeqlH5KYrJUmfd8/MmsylAA9dm+T2tslBSXKouQwkAwZKkltgcjRLSf4rGs3ONFd75Sso+sSOm66/Mppto9M0Xi1NkSJg3ExNNydxjtufATQ0muXlVJnjg4CHvo/n1bIoko0Cc2nr5uTa5PbLgKabDtU4ve3PTaSBnrX0j4L4aPVuf0oCOukaLx/142CkkAY0L+nh5qJuab0dTwIYWkefx/MQS0EmRsOA4SU1ODzUS1pv21NRQOOjEoiHuKS/tCKjgLHzDfU3PNSl0zS5HOTcpdRy87E1JWLlFbmU9m1eLv0GGIdoRc4E8WwfrUhCCCGEEEIIIYSQb+xdV48jRRB2z4w9wR7nsT3OOaztjdo7dOGBO3G6B0DkDA8IpAMhJECAQEggosQLiJwFPJAFCHgAgUSqH0bV9NjjSfYSd5H8SWiPnbl21dfVFdpdfWussYYNVY+s8Y8gz3767zrV87Hs3x5DP7JzL9Wh9be1K5cO9uKkvp9bceI3VlrVF1W8+YjeUiAJIC45gDs+0BjFSx490LEgZoC4YqjuVZ3lTHa3cYwjCaTyWHkcwlh5Cs8cbIyd+EHeGwAoK4faXMVk5UhapZ6PCWBqlzwULH+6D5BaaiSjsaSqqD+8U5IQ+cgyZARIrp6V6MGYVMujKsvkI0cDpSor1mVAbISsmddguSctd9s9QdOQypo2FQTho8LSCJeA5t+hUs10E8SkrkoxxrR+24SdQuTwoGYd3V4/BYiKErpiYuYK5S8HN5JLgw5A7m9QmWfaNiRvHaMBaMIucHQihwaVaV/Os4mCqHwlwP44FpakSDJqthS5lhiNkmVHCeISqkrMgJOSFBul/xqVEqsDbA3Y9L4tQBzfAdg43JtyXgK4733nqC36L+OjnryfC9MMqgxRXjpmFQBWxYJsdQrQqwuCfFPqr1DZYChLQngBAPbaDz70C1Rah95tdhLAeMtWjw1qCQDA/1qhVMomwAqXGTOXh2a13Jiwrgk2lD9PpV5lNbAQvXDd3c8kK60PShLGHaZGDhP3zLXJXkc0mo9fAScmbBysGcdGaimVcojT0iVc0VUKETWD+9JoUywsGymYSr1aNAExLMQj+Yf3zj09Yaw7Fdp8Cg8RKbGF0pF7vC0BBKPXk4/DZjCVyup1RFSKwck7hnUya87j6iU5DnbOUnELoPLeV3lcSKxeF3q7x4GjeZhJZjrN1X87h55SgzmGuWAq6edqAoIza/0i4Li0ZhDbK9Ho0QeWJO+6FWFDQUJPFNLX28skKl7Adw/LXaolKYYr4+kUkTTZfxE95TYgKpudVDxQqPyMSlVVl8VdVOoqWsi+AjreEkWxo8SrXdQ+shqxGkCMsekJJWz1p0Txglb70ZnnQwC5rOm1V10BEKUcTTD6uzS7d37/WWzk31UY812YL+AaZB+haTcHRGVkWJJGMQquRk02Q9M8iTnPVrqKvgwkox/MXv1SHwc7TCpVno+fq6E8ecrRgPKJLHv83K58k9cau/JDeply4b4gywYQ/OuzzLoaljpCWwaOMLrSGYHIOSCVhGQhYBRmDZKlYhcElj0kKgmKoqTQGwkgZtnV8/w2B5VrDF8cfBzgkmJ/CxawkfMt/0vclU6zkAohaJCAZCqi5qVxDCHl9dCKSKYov6kE2sIA4LJGhnXrnO/rhcPylY43umfShaQtbVklU/BRmTdgbweg0kRHdz2ldJUglgpJIM2jF8lLS7gyw+evUtlcF17c3ZVl4eqwuMuMcEvLawBnXib3TtholYTDTYWIt1eLx6E1q+ZeeYR+JXpDL5rtkOSknYM++De2/Okn957ZAI9KAyQuuWYfCJXoxUtqdQYAS3apQcwlIXpTDawibEqVwyGCySD05o6rMYXaSxOi0oO3E7CTLpMlCTLQ6lxNJfeet/kSoknXzs7FgmLFP1zu8OepJNeEvklSy1VK4dpb3H8fIhiA7PiYCU2wYcDQ5+N7APUBBVPCZuRgVEp9/5obFQ1AdFzRfDNcuo1lidIF1hW0vgmE4ZTGOUQwQDRnFsMMuBMCc4+7AWYVxbATsulVXrAXsDM/aHodZRsAdS8sRvNkqK9cEumrMoAmgI1WnL98iGAAzta4WgR4oE4ezB8v2+TXNltK2NrWM3VoOfYC5Hknsle7bIY8bRFAdKI58foXqCRrtqqnaN/aiToSVDbnfGkA3QQEOqjnUH3ny9J0LFby1sUJKCxkg8Tk1PBop1dp+BybUykxzvZfoZJsQGwptkc9GlQWFqm0mHQ5y6yUp8K6t5ujZVU8G7eSOll+3R2XBdTMofIqqvcMr68Y045Oiz7007JVFzFhaRDL0N/PqhyeZUKSu4JT7PCo9G/TEpVJ2PZE1Fj3BJI96sEpCkwm3M+NFOlwmRtAM12SxkgPk63CEcDrdkusR78g3U2tT3VReBDLqiWpkUFRGBVRhAeyLiq1OZUTsk9rBpORQ0TpJFRc4sUto1rUide6UtsK9GXDtuJrKAy7NxA/ZoOp0JNhjrabSj0z5SGGgQP3P9WYxiqeaqAMETgVaglYwF5uUSyHygbK9F2Ey32Y6IgLAj4A0PKKNOpa671MaRzqeonNThp5unSmlsWkKc8V34gOReXrbs9NZbWY4PRX6Q1CczM6TLnMdkBVfE/Godzwl/3dOZX6OQD5bOnQqXQhuweC5BZJZW3LDvULXJXfdmxH+ho4zrFrzjgcUuJt49lF9fVsg5mzEFcJCdrqk+BDMspRgWTO7UfnYsZF5X6Qp0eKykhOfBaonok7hqIhQVxe0fptSuEP0yfnqX12n5cvisd5fLTgBKRitwYrj1IoURsiTsnyDfux26U/ehzgSFGJeNjz1VUnbGsi5VCXE1tBaneSMIw7JRAP1v8YNt3pb3z/yFGJO2r/xm5VSQBaof8mxOhm5Iih8q/kZ531bZ5rrLHGGmusscYaa6yxxhprrLHGGmv8n1D+bzvUdCkb+f8hnYkdpKv7wULYDmxMOngDdVZKH+Q1OhWe+zvt2hl2oKkYxxoS4p9qKGkM9lbvy8bqEPZSeSpf+82Bp617V2rpC1l7UAGGYSQ77drhrLIE5DjzS2liPbkmCMIJ5cBt90i8Hvo0U4Ph6m47ObwX8QKA8WT6gNOWACUiZSb5sCkb3Mpf7IdN3cjpL2+wR5acsirw14tfL5s54IgezA4YNT8KD4d9aL6YgNaqyZhoACk63xDc8rQHcPrX5a5WtYRhNUgSGwnj2RCuZXiPz2+Iejprz8Qts3OQC6eSEx5rQyHc3eipjkhYtlJKsQxr0Mc1nt4GQuiA1Xp4S3a5ZCtYNOBMo8pY95HA9+JnABKvLPNJ7IJiGSXAJmpwJQBcFDzzNdhL0VGB7ZD5HRcBcraRXBJ++jEzp1KGe0pSI6hRRW+w2+KRlRjdIVNvtMr6Z+gr4DqNHCw7M6ESSsCDHX44rAaJ4rRmhrcPPnYFwJB7k5KEKHmC1n3QsoyST9u9xyFMoLvxAep4A2zEg8WdHygeDfaS4c3RCYjOqPyoOBV4o4q3F+8cKLTU8hIhNE4NDSAqNa48C6VyPAg32BgXu8wEgK0dQIQ7zPgzcNGY5r6oTcmRd1xOpg6kNX0WV/D8yTD/VGrDTrVYC/tWtjq/0kFlV5JO4adO93Wbymu2AxtVRsUtuNNaalpdIJFzIcmNWrQo0pDDpVRmeu72YH9HUJn1AXG8L+wFD5KmFlWSSOjJN4CNoUv/PVJDx8+inyq+/9nt7dsWcxLHCd8B0N+C5LcqmbYXZK5Re5412BhJwS6wPGImGHfFOZVNPElERzPcatJxm/agf/sWQGjsKQ+26ZgYt0fmULn8jgTSDzte0i4Pbw1fegUQiV7b69/Kko4sxjJ02qw9kyhhcrEW5JZQ/6F99PQKfJ1p+L5s7uQcrnvyT/OlYADA1nVsoKFp+6StkXlzJk6DWG1fq3u7z6RRhnX7bUAonErR9vvuV8dIEF2BUDn2Ii5/fzRx8giJt+/EAPbzeiiVlC/CT+MYs/U7fSzlpHdqkc9UZ3gPcLhDAesLRWRxd9s+arZ511lt0EuQSSqeI6fJ8ypyjiKZNedEmUOlvoVqcYaq1lHKHn8r6mXSudFhoiGp+Pe2vnNZWlfThHbCbpiK85Uuopk2Mqz/etzrvVJKSo0x7bT1dirATdRmVPJJMYSr32WBxzfVfAMFT2h95wRjMsV9xOBzVS/b3iEtZeh4d2UDKjlPwsFJ5E0eJJQ1jkcoOnJ6ByVkDolQGYquI+jxqywbyk+YZsIMw5Z7oBIxeft529INki1+EozndNfBLg5zNg/MhBMMzbSW8FgTk3GpqCN2dp947FC/qh5wOL2pqg1OJbOUS7g6ALMSgjek12vgqEeM2EaJ1NW0N/r802MD9JLJVj42ytqLyO5SRhabLYVfPaJzIv23TUjktnpEkN1bIwYeJ3uIqIx9chwIN7wAcOZnb0idTAFxKs4t3XbxdwLc5xhmx7Llzc55NqcSwJADGv/S1kKN/TSEYw/fPIrxftW4t7UKQChqWo1TidLf6HGqUlcgyPP5R6/saVP4GQht/rfSx4COj43q8gufVxnFl7P4Nvfos2RZ+7zIiQxqDOag553welEkPeis6QkTftk59xrrnvVQXr4RbqyR9erqpDu3MfR3xllvrcV9E0G17WSzkPP1M7Yi6v4rL1uuXg7qVy13AfaAYFN5WXXqplJ/GGZIAARn+sowaT1N8vOPv2F4Ycis3LajCqeS/+SNSWcoygdQlT0GyaHYSTVmDdvU0zny1YvfLhY88kDrmf6Q2rplUicqpaJmOHnnvSf9tRYlgU0sZkgTf/AmkPc6yxh51rnTaXleG6FaV2G4RXAz3i2aHhceL4iIFrZpGjw9z5bKATX6A7KV06TzjQnNnAxzbBRsnaPOScfCSxq97kdO4elADeBcSbJ7Ooe+vsiUJQg9r4ER0ok7Lho0uQ3BNnAM15NJJP4p1Vo+KsV85luLG53a/6qNrCtdqiJNPHBzNxUPShTbsM16NnlkxgYK1g/KmsYUUh8rUfzuTi+PB+2uwI9EY71mAAfZ19zVSZiZOFRexIxlfapSERACtt5zE/Bd6NCyok6XzxiPBByedgiRN0RdM0LWyaiOo6k/ugcw9PbQvpp5K5my1CxSj795+0xufYyf0ze5HGd6oVKXkABTthYnzy4Re69rQVRmMHG5khWnvV1AKIENONp0RmOl6Z0PItA5NCosb26fzK9uub1NrtcjdQ8uxneuPg4cu/cG7sxMgdY1Oe9Tg3ZbOD13NvGbALw9tNc+Y1VMZdbbwZe2MGDNTLJ4n/U5x068GbcYekyasFHA1sp0MXsfcQXa9MOXCpHV8YtLjEAWGNiguPUF/b+fyhT/0xSgvfQwc57xGdlW8E/+D9OnVkDeSEabLSsdOulfJLrVUHuBO+/It4BIYOW/yd9Ucl7RkpXUzI8XeL/L7JUcP+We6T7RsZyFNhAMGAbtPiI23uR2mGnPwwsEbJwhLo5uvllsB7VXlhk3xkIq8ipx6aOSblNRbMmdABi+/5Q8g3TuV+tBdUVxvixKDAif+lOBoul8CNGp3PoWNAMXp04mVInPM4gsJodIpeIr9FqWszADL4DIU3EGT1gWvskNL64oKQ18O2m0cYbYOm+1ERUC7KjvtIXdTnUV8zasx8WWYwRLl3eWWa2xt5K7NIOK/uq8khpP0c0FOByJyb7ivqAEO7lMsT0fgMyRiqCad6ondeKEj1rhwdv3vHUOCqScSHUmV5CBf05w7Ee3kMu3kf0NL4+xMb9HZKGyS4Z3pY9W9SpQJkSG/4M/5nCMTBg6+yvnUbaTXncjAOxMTeJDJQlHEb2EhQZC9RnBNAEuKm2IPpdzQmeUj6TCXFI8snnRyKKy2rMnu+odKJ2xzPY8UmT6Y1ia1eWeq06On1pGZawdnn7bu+e8ctVvD7l+Ld8mueleMJZAUt/19yGXASqfdVGibLWK4rI6RcyPTuBNGftu6S0jcKjMWFQm92WUwGN0iNPFkNUkEUFNeo+2RsQ0LStemJierUZy4WQcHxpBS3M84A52kWMltYRKr5z+8WxBPiO/9E7Ej08sO0w/JQhEoi6Ab6W0xG+YDJVS5vpKxeqSvZQoOnbac71vgzKma8y56CxheU3Jk2BIZHTbPNMJVElIcJFLxFCL9v8rONM65m3egUx7QV5PhL3l2/MlKbsuKh0v4cdEXhZz+Ebl/bGsffUKJG71Wq2at68KS13BPcE3+CMwGfo+805StMsZ2gChG2ULLiZr+CTmBJkqwB5tp7qp1Cmnbt67BYjdvB64V2sb35NEZaZGM5x++doPpZ7LolQauMPF65Nu13use5eai2IHptKXnft75OHRO07fRjcKEBJvLj5FPQdanSSUEOf2b8vOe055nVlyrh84/fFNSWXe0avHWD3hdr3EpNkYEZU2/yaA0PYWfCMSKUX5KEKuv1FOR/z+xG4X3Ae4nCWsqf0gYfzuSiyzGW1mRSMUj/Cg23eL1L46zx/SsfIKKgHgZglRDrxaLSPQ6nh+K/EA3SjQJFN4RXeeXrsFHIZgoa91JyMciVrBJ1ad2eFxQIbEgzuUd3MqH8mwIhUjLn8hAaE2j+AqKWijuWC7bZsB5RQQ2v3XxqrHn8Tn7YKF9HX267cmwODOyrlm2fzK4oiGvOckAJhn874MpmbLo38lE9XhVFZJGJsGTcuMvN+28SByHqmgcoViHVz54fx5shLdAA+MNo5EreAGEOybNBCV3LzI/qJrs6S4rSB6avG3Cr/UUjAdH6RSnT/fD+kcAwtm74HYWFLTwd2XSdtGv7fHdpisPAEXNapsQDsW9N0rQr66Ucq6NyKSdoITvwvklxrhVGa3YBGJmzxHIOwY8g2Q3+BfkoFxq2/bQ1E6oohUgA+04nBJOhWnTuuq5WxXu2H5QMVXb3RmoUCzBHF4al1sCy73BO3upede9CsXqFSv36GvXlpX9msm2B6hc6M1Um16XTqkFXkLjBqNEfLYpb77NdW5TKMzbFoKxO8M/2ae6zbcAXA26RW7AEw6adTLZAOhOH/KXb9R/75TGeSv8m07pQrOJz5xV6CWTlroNE4rtkendZCceYTCpWBhJyzR3vdy5OfTsqrNaNTTrnpzQNP2e7SluurmabGz2MB9l+vatuwODJcprHj0SG0sTF1hiGr7oIjRJCCayM8yKAEkKK5fKk1rXkKHuWWH5yl/HmKA4KlmlKt2cCieiTuS/zyBI55rMv0XmK57htdYY4011lhjjTXWWGONP9o7t9em4SiOJ6ZdmzVZ0zZNa7RdV9dq1zm3iRe8PKgoPkzB+1T0SUFFfFBUFEEfvIAviuINL6gvXlFRUUREH84f5u/8Tly6XNrYNaLSLwxGL0n6zfldkvw+53TVVVddddVVaFJN83ehW1mbaXUb4d8T86k1c1utftaF4MqL4o3kzGpFT0LAc4ZShVBVw8Jy6WGRabje5FBSuZMtecrlAKwwXFAzKQXtUNu8LFEifS1RUapv1Yu6qQkhqlaGuJD/vIyzUiP+p//EWGvINTEwAVS+MKD2xgBmwMtqnJVoIpUvez6wYsluGyMJT2YZHzLPw0zEAHN8nSxinu0Aii/1f4zkU3WvfV6W0MRm5yL3fMMyFvl8xXMizhczhCetChNTPiT8nYRjARvtu+WXeSpzsRbQyrZ5WWG40twb9XsfLJ1VHmhYPyGEqdtuEtrLyfL6xy3OiWxSp8SY01gM42lBMCvb5mXzYrZFBeNEHNf095k1naxE50OUOZuW+qX1iO7v5KXVoDxXPb5NUBZ6OB/rvmXtZ+AlB24jm3VGYrqtbJuXrS30Xc+Yz1unV833MgBm/R6DrAyxyha18DVyBFmL4grDc9kvX674gcVZ+aP7zSpBWauXgaXogsOv91652JN3zhR6ESNcmnRZ2S4vq4llGCJIjgH4vLqKfVif5tGyr97cQqBVauFbmdbnAzBWNsZt8KwGT68nVwIoV5yBmWnIoy9J585EarTsqhI7Pj1g9Gvu1R9EDbXLy0bYgZ+OUIUJRuA27tAcpElSehxI1lnBvYWhNLY4DEZAEcLatK7+QaCi154yxVQ/L3ReznrXbTSi2yvOaSStcG6Hl03nObtULCLK6tphhFKh5IenijAcz9gB3lmpGDyDBO5ahJRnin3ZdpKgRFDOy949ahWUwiJgUrI2xOsqn3VCdy7fln6Hl1UjqBpHvzh0TRrCklQZV9Fm8cAyaPRZDKNgmZzjwUPi1Xu1iOpdV5+cJGVWAiKenmZuw2VLS3YsLMY8jcTJDUBBUR4hetDvKNMclJeVc7NQ5VgDUz3PHQPEcGr9kJ1txUlSCK2e0RnrbCLW+pL9dNZD30p4jd3MSWc2HSzC4jGeKgAsawidIa9kFr0AK9nfYgY1FWMHbSsD8rKkd428rF0g2m3lCA4628d4qOyyXx4SOq94fGpCXkceh/bu66Qm8+wpppakFZ0HXGZGymApevS7rHoBZco6vEqX+KJkw7YyIC9LouxC8TOYQCLJD8wjwZlIuSKiEF1fQNd3YLcSZj0jNcI6TJNjimBQm2hQfi45KbOuKYWzRp49ZX2Srg0h65zRmbOwuR2+/IpPMc84qWKrtPxyNMYssP9sK9vgZXUE6iRMRcH2tTzpm/ZJFrOwZxHbULGnroVnpZ7KYXMcENRPAJNopQO5nI1OmsjI8iQbpD660PbABQ8BJmj4NYTH3UMOe18XpKghyIgI2Fa2wcvWillYlmM7G1cwzv0zaGHZP8pEETuVDMfKdIoF3WKLaupXABSnlRGruNAA+jeOQ5Nk3GCv0fhTikrTNscSFeUqs4kE9sh5kD+JQ8Tn4urnPTotR7etbIOXVZEAXbTIGjP7Et5WEk/ANTKBjodjpTmoTHJCfQzR4gL715XUSbLz5ESI5E8jmuKD71XG+S+bjakD3EtZ8daTkWaQkLJlk+FjZXBeloATmIiWHj2j8q/eVqaJJ0BcBBnVBO4uKXRa2MZGsYAXyxlk9hxpjt/mxVkUvYO+9+FKlOtFe8OncGk3uaJFGBWfBYx0HyuD87I6dRfKfgSC7AhwJCpRI6nBxVChXomL8KpOS2NHGOMT2HM94tdNBWiWaYTqBGLYoKP+YrzOmwpAgVdb3DsdYhWR3GYaQbz2V4mzmm1lcF6Wgk3agFfWomecyfP5TPnh8jEoidSJhWil8Iwjl7Ngd2r+cTA+KoQhaJrgFgfjDQobSPjc9K9bybEqHrSsnmIQK5DiWm34wRh/lyZQUmBe1k5/xDm07czLqvM9m2dBAEoyBJE67jCtrGWhtJM1gN7qGFi911m2syPuc8zrBEYpbLzbd53KXyrQoKFSouERjIKvjFyMAVwR3ywYig9Qb0oB+Ju8bJ0oT+JwvHGFnO0wXkCJomiGaGX+GuxgUYZZLAxKcwajSUGP/XA7WaADZmHj0771U3byqFMxACfyoS7F3CRUenrnWkr04LAyOC8rixWrL3rKTIaDnlc7tvt1IA2EZ6VwdpzNt5RRypcwfB2YlrDi/u4uHp3MUFD6DYCGxDQvbrvjUCIzlfAAkBl1WRmcl1Wxox2xGjowfVG9Lhzt5jPSR1RgeFZqvJ6qtY96amIOwynhsGAunuaDanLavWhSUAZ8xkCbcGdCHeRUHUNYVceHg/OyKhZ4jdI32JlBFR67D4J59ushSY3lXUtREx8Oxcp0aj4eCDW2Ws8l1oLv4HAufDs6PdNSFWPkM2wm5jPetpVmKlegqZD6dnz9U8eHA/Gy5OQkKOtUTDkkVtmpPcjv+5mqu05khoUtPiTBLJF8cvrNIrY7LF0c5COBteEFUYxN1shHN/Y8u+ok9UuCOj66M6f4P9yl5tuvYdfqbaUsVhXcFOVAmeh7VdPTVhnioLwsOclyjb6AC/d7xFyFI7ibgSlbvavLQoPu8a9EVkKDYhdF6PxzsrxYtEKyUdokpjaJLW54VV5Cv/V9Nqu0Csp9ULhd14cLnu5o6wAgOvX9uFkuF3fW+q3JTFBeVnu4CmnR+FZ+z5q68AyRzOVib97FhGPONQthRP46FkL1Vh279qhrCHmi8NQma6eBmPFfY0HLW9DGbvbtYtbbnWR0+uXkN8x+UbZ9D8bLJiW6jrhk36jnd1dI85pu5wKlpOm0DHy06tZ+5qXPMB1l80KhlbC1BS2Sm7QMkALcWvVkOhMN2+K3K1olif9Ge/tD2j8KM9pfhmV8HDKCfrg00bkfl2TUdOvPZIQ/p8zSP3rqMpL0VwPNM1P8v/51XXXVVVdddfU36ifmSuwJgcsVoQAAAABJRU5ErkJggg=="></div>`
			document.body.insertAdjacentHTML('beforeend', html)
			let cover = document.getElementById('cover');
			cover.onclick = function() {
				let shareTC = document.getElementById('shareTC')
				this.parentNode.removeChild(this)
				shareTC.parentNode.removeChild(shareTC)
			}
			new Promise(function(resolve, reject) {
				setTimeout(() => {
					if (document.getElementById('shareTC')) {
						let shareTC = document.getElementById('shareTC')
						cover.parentNode.removeChild(cover)
						shareTC.parentNode.removeChild(shareTC)
					}
				}, 3000)
			})

			wx.ready(function() {
				var shareData = {
					link: opthions.link, // 覆盖分享到微信的链接
					title: opthions.title || '普法|无“疫”一身轻，复工必备秘籍', // 覆盖分享到微信的标题
					desc: opthions.desc || '返深必备，警方提醒，依法隔离，无惧疫情，我们一起守护深圳', // 覆盖分享到微信的标题
					imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					success: function() {
						// 分享成功可以做相应的数据处理
						// Toast('请点击右上角进行分享操作!')
						// alert('appId:' + res.appId)
						// alert('timestamp:' + res.timestamp)
						// alert('nonceStr:' + res.nonceStr)
						// alert('signature:' + res.signature)
					},
					fail: function() {
						// Toast('请点击右上角进行分享操作!')
						// alert('调用失败')
					},
					complete: function() {
						// alert('调用结束')
					}
				}

				wx.onMenuShareQQ(shareData)
				wx.onMenuShareWeibo(shareData)
				wx.onMenuShareAppMessage(shareData)
				wx.onMenuShareTimeline(shareData)
				wx.updateTimelineShareData(shareData)
				wx.updateAppMessageShareData(shareData)
			})

		} else if (_that.isEquipment().isQQbrw) { //qq浏览器
			const config = {
				link: opthions.link, // 网址，默认使用window.location.href
				title: opthions.title, // 标题，默认读取document.title
				desc: opthions.desc || '', // 描述, 默认读取<meta name="description" content="desc" />
				imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
				types: ['wx', 'wxline', 'qq', 'qzone', 'sina'], // 启用的社交分享,默认为全部启用
				infoMap: { // 针对不同平台设定不同分享内容
					wx: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					wxline: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					qq: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					qzone: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					sina: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					}

				},
				fnDoShare(type) {
					// 执行分享的回调，type为'wx', 'wxline', 'qq', 'qzone', 'sina'
				}
			}

			// Mshare.init(config);

			Mshare.popup(config)

		} else if (_that.isEquipment().isQQ) {
			//接入QQ的东西
			Toast('请用浏览器或微信打开进行操作!')
		} else { //浏览器的分享
			// Toast('需要在微信或QQ或app打开进行操作分享')
			const config = {
				link: opthions.link, // 网址，默认使用window.location.href
				title: opthions.title, // 标题，默认读取document.title
				desc: opthions.desc || '', // 描述, 默认读取<meta name="description" content="desc" />
				imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
				types: ['wx', 'wxline', 'qq', 'qzone', 'sina'], // 启用的社交分享,默认为全部启用
				infoMap: { // 针对不同平台设定不同分享内容
					wx: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					wxline: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					qq: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					qzone: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					},
					sina: {
						link: opthions.link, // 覆盖分享到微信的链接
						title: opthions.title, // 覆盖分享到微信的标题
						desc: opthions.desc, // 覆盖分享到微信的标题
						imgUrl: opthions.imgUrl || 'https://300w.oss-cn-shenzhen.aliyuncs.com/15514636798751bidibGWQtmx.jpg', // 覆盖分享到微信的图片链接
					}

				},
				fnDoShare(type) {
					// 执行分享的回调，type为'wx', 'wxline', 'qq', 'qzone', 'sina'
				}
			}

			Mshare.popup(config)
			// Mshare.init(config)
		}

	},
	getUrl(router) { // 分享的url
		let ip = window.location.host; //获取服务器ip地址
		let protocolStr = document.location.protocol; // 协议头
		let url = `${protocolStr}//${ip}/pckm/${router}`;
		return url
	}
}
export default util



// WEBPACK FOOTER //
// ./src/assets/js/util.js